import ErrorRouteFetch from '@components/error-route-fetch/ErrorRouteFetch';
import Feedback from '@components/feedback/Feedback';
import PendingElement from '@components/pending-element/PendingElement';
import ScrollToTop from '@components/scroll-to-top/ScrollToTop';
import { LayoutProvider } from '@context/Layout.context';
import { LiveChatProvider } from '@context/LiveChat.context';
import { ProfileProvider } from '@context/Profile.context';
import { ReactQueryProvider } from '@context/ReactQuery.context';
import { SushiTailwindThemeProvider, SushiTailwindThemeProviderProps } from '@mis/sushi-tailwind-react';
import { FilterRoutesFn, Outlet, ReactLocation, Router } from '@tanstack/react-location';
import { rankRoutes } from '@tanstack/react-location-rank-routes';
import React from 'react';
import routers, { LocationGenerics } from 'router.config';
import './App.css';

interface NewSushiTailwindThemeProviderProps extends Omit<SushiTailwindThemeProviderProps, 'children'> {
  children: React.ReactNode;
}

function NewSushiTailwindThemeProvider({ children }: { children: React.ReactNode }) {
  const NewSushiTailwindThemeProvider: React.FC<NewSushiTailwindThemeProviderProps> = SushiTailwindThemeProvider;
  return <NewSushiTailwindThemeProvider>{children}</NewSushiTailwindThemeProvider>;
}

const location = new ReactLocation();

const App: React.FC = (): React.ReactElement => {
  return (
    <NewSushiTailwindThemeProvider>
      <ReactQueryProvider>
        <ProfileProvider profile={null}>
          <LiveChatProvider initial={false}>
            <LayoutProvider collapsed={false}>
              <Router<LocationGenerics>
                basepath="/digitalipo-structure"
                location={location}
                filterRoutes={rankRoutes as FilterRoutesFn}
                routes={routers}
                defaultPendingElement={<PendingElement />}
                defaultErrorElement={<ErrorRouteFetch />}
                defaultPendingMs={100}
                defaultPendingMinMs={100}
              >
                <>
                  <ScrollToTop />
                  <Outlet />
                </>
              </Router>
              <Feedback />
            </LayoutProvider>
          </LiveChatProvider>
        </ProfileProvider>
      </ReactQueryProvider>
    </NewSushiTailwindThemeProvider>
  );
};

export default App;
